import React, { useEffect } from "react";
import { Card, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const InfoWindow = ({ close, data, lat, lng, setCenter, darkMode }) => {
  const history = useHistory();

  const handleClick = (data) => {
    if (data.serial) {
      history.push(`/equipments/${data.serial}`);
    }
  };

  useEffect(() => {
    setCenter({
      lat: lat,
      lng: lng
    });
  }, [setCenter, lat, lng]);

  // Cores baseadas no tema
  const bgColor = darkMode 
    ? "rgba(30, 30, 30, 0.85)" 
    : "rgba(255, 255, 255, 0.85)";
  
  const textColor = darkMode ? "#e9ecef" : "#212529";
  const borderColor = darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.1)";

  return (
    <Card
      border={darkMode ? "info" : "success"}
      className="info-window map-info-window"
      style={{
        position: "relative",
        width: 375,
        transform: "translate(-50%, -100%)",
        backgroundColor: bgColor,
        color: textColor,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        borderRadius: "12px",
        border: `1px solid ${borderColor}`,
        zIndex: 999,
        backdropFilter: "blur(6px)",
      }}
    >
      <Card.Header 
        style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          backgroundColor: darkMode ? "rgba(0,0,0,0.2)" : "rgba(255,255,255,0.2)",
          borderBottomColor: borderColor
        }}
      >
        <h6 className="mt-1 mb-1">{data.serial || "--"}</h6>
        <Button
          variant={darkMode ? "outline-light" : "outline-secondary"}
          size="sm"
          onClick={close}
          style={{ borderRadius: "50%", padding: "2px 6px", fontSize: "12px" }}
        >
          ✕
        </Button>
      </Card.Header>
      <Card.Body>
        <p style={{ margin: "4px 0", fontSize: 15 }}>
          <strong style={{ color: data.isConnected ? "var(--success-color)" : "var(--danger-color)" }}>
            {data.isConnected ? "Online" : "Offline"}
          </strong>
        </p>
        <p style={{ margin: "4px 0" }}>
          <strong>Locação:</strong> {data.located ? "Sim" : "Não"}
        </p>
        <p style={{ margin: "4px 0" }}>
          <strong>Versão do Software:</strong> {data.versaosw || "--"}
        </p>
        <p style={{ margin: "4px 0" }}>
          <strong>Versão do Firmware Osciladora:</strong> {data.versaofwosc || "--"}
        </p>
        <p style={{ margin: "4px 0" }}>
          <strong>Versão do Firmware Principal:</strong> {data.versaofwpri || "--"}
        </p>
        {data.calibrationDate && (
          <p style={{ margin: "4px 0" }}>
            <strong>Calibração vence em:</strong> {data.daysToExpire} dia(s)
            {data.expiredCalibration && <span style={{ color: 'red', marginLeft: 6 }}>EXPIRADA</span>}
            {!data.expiredCalibration && data.nearCalibration && <span style={{ color: 'orange', marginLeft: 6 }}>EM BREVE</span>}
          </p>
        )}
        {data.dcal && (
          <p style={{ margin: "4px 0" }}>
            <strong>dcal (data de calibração):</strong> {new Date(data.dcal).toLocaleDateString()}
          </p>
        )}
        {data.calibrationDate && (
          <p style={{ margin: "4px 0" }}>
            <strong>Validade (prevista):</strong> {new Date(data.calibrationDate).toLocaleDateString()}
          </p>
        )}
      </Card.Body>
      <Card.Footer style={{ backgroundColor: darkMode ? "rgba(0,0,0,0.2)" : "rgba(255,255,255,0.2)" }}>
        <Button
          size="sm"
          variant={darkMode ? "outline-light" : "secondary"}
          onClick={() => {
            handleClick(data);
          }}
        >
          Ver
        </Button>
        <Button
          size="sm"
          variant={darkMode ? "outline-info" : "outline-primary"}
          style={{ marginLeft: 8 }}
          onClick={() => {
            if (lat && lng) {
              window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank');
            }
          }}
        >
          Abrir no Google Maps
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default InfoWindow;
